import { useRef } from 'react'

import { checkUserLevel } from '@services'
import { useMainQuestActions, useUserBankActions } from '@store'

const SYNC_DEBOUNCE_MS = 1000

export function useQuestStarHandlers() {
  const {
    decrementTaps,
    incrementStars,
    getGetTapsBalance,
    getGetStarsBalance,
  } = useUserBankActions()
  const { collectStar } = useMainQuestActions()

  const pendingStars = new Map<number, { stars: number }>()
  const syncTimeoutRef = useRef<NodeJS.Timeout | null>(null)
  const abortControllerRef = useRef<AbortController | null>(null)

  const cancelPendingSync = () => {
    if (syncTimeoutRef.current) {
      clearTimeout(syncTimeoutRef.current)
      syncTimeoutRef.current = null
    }
    if (abortControllerRef.current) {
      abortControllerRef.current.abort()
      abortControllerRef.current = null
    }
  }

  const syncWithBackend = () => {
    cancelPendingSync()

    syncTimeoutRef.current = setTimeout(() => {
      abortControllerRef.current = new AbortController()
      const signal = abortControllerRef.current.signal

      getGetTapsBalance(signal)
      getGetStarsBalance(signal)
      syncTimeoutRef.current = null
    }, SYNC_DEBOUNCE_MS)
  }

  const handleClick = (starId: number) => {
    cancelPendingSync()

    const taps = decrementTaps()
    if (taps === null) return

    const currentStars = incrementStars()
    pendingStars.set(starId, { stars: currentStars! })
  }

  const handleDisappear = (starId: number) => {
    if (!pendingStars.has(starId)) return

    const currentStars = pendingStars.get(starId)!.stars

    pendingStars.delete(starId)

    collectStar(starId)
      .then((res) => {
        if (res.ok) {
          checkUserLevel(currentStars)
        }
      })
      .finally(() => {
        syncWithBackend()
      })
  }

  return { handleClick, handleDisappear }
}
